<div>

    <fa-icon [icon]="this.data?.icon" style="font-size: 20px;color:{{this.data?.color}};margin-right: 10px;"></fa-icon>
    {{this.data?.text}}

</div>
